import { Field, Formik } from "formik";
import React, { useContext, useState, useEffect, useRef } from "react";
import { get, isEmpty, isUndefined } from "lodash";
import { Form, Button, InputGroup, Image, Row } from "react-bootstrap";
import {
  DatePicker,
  SearchableList,
  FieldDropSide,
  FieldInput,
  Link,
  FormControlSearch,
  ManageCommunicationLayout,
  LoaderWrapper,
  MultiSelectDropdown,
} from "../../../components";
import {
  manageCommunicationFormNames,
  formFields,
  getFlowBasedFormValues,
  usDateFormat,
  getPathWithParam,
  MANAGE_COMMUNICATION_ROUTES,
  FLOW_TYPES,
  toMultiSelectValueById,
  CategoryOptions,
} from "../../../utils";
import { manageEligibilityStore } from "../../../contexts";
import { useRouterParams } from "../../../abstracts";
import "../../../styles/containers/CommunicationContainer.scss";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { faEnvelope, faSms } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CommunicationHistorySlider } from "./CommunicationHistorySlider";
import {
  getEventsList,
  getPlanList,
  getSentCommunicationDetails,
} from "../../../services";
import moment from "moment";

const initialValues = {
  fileStatus: 0,
  type: 0,
  search: "",
};

const CommunicationHistoryContainer = (props) => {
  const { state } = useContext(manageEligibilityStore);
  const { flow } = useRouterParams();
  const formName = manageCommunicationFormNames.PLAN_LEVEL_COMMUNICATION;
  const fields = formFields[formName];
  const [loading, setLoading] = useState(false);
  const [tableSelected, setTableSelected] = useState(null);
  const [planList, setPlanList] = useState([]);
  const [gridData, setGridData] = useState([]);

  const columns = [
    {
      value: 1,
      label: "Communication name",
      className: "column-communicationName",
      columnName: "communicationName",
      field: "communicationName",
      width: 250,
      dataType: "alphaNumeric",
      //field1: "ssn",
    },
    {
      value: 2,
      label: "Event name",
      className: "column-communicationName",
      columnName: "eventName",
      field: "eventName",
      width: 250,
      dataType: "alphaNumeric",
      //field1: "ssn",
    },
    {
      value: 3,
      label: "Date and time",
      className: "column-date",
      columnName: "date",
      field: "date",
      width: 250,
      dataType: "dateTime",
      // field1: "planName",
    },
    // {
    //   value: 4,
    //   label: "Type",
    //   className: "column-type",
    //   columnName: "type",
    //   field: "type",
    //   width: 220,
    //   dataType: "alhanumeric",
    //   // field1: "planName",
    // },
    {
      value: 5,
      label: "Sent to",
      className: "column-sentTo",
      columnName: "sentTo",
      field: "sentTo",
      width: 270,
      dataType: "alphanumeric",
      //field1: "planName",
    },
  ];

  const typeOptions = [
    { label: "All", value: 0 },
    { label: "Event", value: 2 },
    { label: "Schedule", value: 1 },
  ];
  const [tabledata, setTableData] = useState([]);
  const [tableFilterData, setTableFilterData] = useState(tabledata);

  const [index, setIndex] = useState(0);
  const [isTabSlider, setIsTabSlider] = useState(false);
  const [sort, setSort] = useState(tabledata);
  const icons = ["", faEnvelope, faSms];
  const [eventsList, setEventsList] = useState([]);
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const communicationMode = useRef(0);
  const [isScroll, setIsScroll] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [filterValues, setFilterValues] = useState(initialValues);
  const [isClear, setIsClear] = useState(false);
  //let filterValues = [];
  const numberOfRecordsToFetch = 20;
  useEffect(() => {
    setLoading(true);
    getEventsList().then((response) =>
      setEventsList(
        response.map((item) => {
          return {
            label: item.name,
            value: item.id,
            eventCategory: item.eventCategory,
            metaData: item.metaData,
          };
        })
      )
    );
    getPlanList(0)
      .then((response) => {
        setLoading(false);
        setPlanList(
          response.map((item) => {
            return {
              label: item.name,
              value: item.id,
            };
          })
        );
        // setSelectedPlan(response[0].id);
      })
      .catch(() => {
        setLoading(false);
      });
    getSentCommunications({
      search: "",
      from: 0,
      offset: numberOfRecordsToFetch,
    });
  }, []);
  const getSentCommunications = (searchFilter) => {
    getSentCommunicationDetails(searchFilter).then((response) => {
      setLoading(false);
      setTableData(response);
      setTableFilterData(response);
      setGridData(fetchData(response ?? []));
      if (response.length > 0) {
        setIsScroll(true);
      }
    });
  };

  const onFormSubmit = (values) => {
    setLoading(true);
    setFilterValues(values);
    setPageCount(1);
    getSentCommunications({
      ...values,
      eventType: values.type,
      communicationMode: communicationMode.current,
      from: 0,
      offset: numberOfRecordsToFetch,
    });
  };

  const communicationNameCell = (props) => {
    return (
      <Link
        to={getPathWithParam({
          path: `${MANAGE_COMMUNICATION_ROUTES.COMMUNICATION_HISTORY_INFO}`,
          pathParam: [FLOW_TYPES.VIEW, props.dataItem.id],
        })}
      >
        <td style={{ display: "flex", alignItems: "center" }}>
          <FontAwesomeIcon
            icon={icons[props.dataItem.channelOfCommunication]}
            size="lg"
            style={{ paddingRight: "5px", marginTop: "3px", color: "#777777" }}
          />
          <div style={{ marginLeft: "5px", color: "#307BF6" }}>
            {props.dataItem.communicationName}
          </div>
        </td>
      </Link>
    );
  };

  const sentToCell = (props) => {
    var emaildata = props.dataItem.sentTo;
    var len = emaildata.length;
    return (
      <td>
        {/* <Link
          style={{ color: "#307BF6" }}
          onClick={() => {
            setTableSelected(props.id);
            setIsTabSlider(true);
          }}
        >
          {len != 1 ? `${emaildata}` : emaildata[0]}
        </Link> */}
        {emaildata}
        {tableSelected == props.id && (
          <CommunicationHistorySlider
            tableData={emaildata}
            isSliderOpen={isTabSlider}
            setSliderOpen={setIsTabSlider}
          />
        )}
      </td>
    );
  };
  const bindTypeData = (props) => {
    return (
      <td>
        <div>{props.dataItem?.eventType}</div>
      </td>
    );
  };
  const bindEventName = (props) => {
    return (
      <td>
        <div>{props.dataItem?.eventName}</div>
      </td>
    );
  };
  const bindTimeData = (props) => {
    return (
      <td>
        <div>
          {usDateFormat(moment(props.dataItem?.date))}{" "}
          {moment(new Date(props.dataItem?.date)).format("hh:mm A")}
        </div>
      </td>
    );
  };
  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) return;
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (!isScroll) return;
      var fromCount = pageCount * 20 + 1;
      var filters = {
        ...filterValues,
        from: fromCount,
        offset: numberOfRecordsToFetch,
      };
      setPageCount(pageCount + 1);
      setLoading(true);
      getSentCommunicationDetails(filters)
        .then((response) => {
          setLoading(false);
          if (response == [] || response.length < numberOfRecordsToFetch) {
            setIsScroll(false);
          }
          setTableData([...tabledata, ...response]);
          setTableFilterData([...tableFilterData, ...response]);
          setGridData([...gridData, ...fetchData(response)]);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  };
  const fetchData = (filterData) => {
    const data = filterData.map((item) => {
      return {
        id: item.id,
        communicationName: item.communicationName,
        eventName: item.eventName,
        sentTo: item.sentTo,
        date: item.deliveredTime,
        type: item.eventType,
        channelOfCommunication: item.channelOfCommunication,
      };
    });
    return data;
  };

  // const scrollHandler = (event) => {
  //   const e = event.nativeEvent;
  //   if (
  //     e.target.scrollTop + 10 >=
  //     e.target.scrollHeight - e.target.clientHeight
  //   ) {
  //     let gridLength = gridData.length;
  //     const moreData = fetchData(
  //       tableFilterData.slice(gridLength, gridLength + 20)
  //     );
  //     if (moreData.length > 0) {
  //       setGridData((oldData) => oldData.concat(moreData));
  //     }
  //   }
  // };

  const tableDataAll = (val) => {
    communicationMode.current = val;
    if (val == 1) {
      var tabdata = tabledata.filter((x) => x.channelOfCommunication == 1);
      setTableFilterData(tabdata);
    } else if (val == 2) {
      var tabdata = tabledata.filter((x) => x.channelOfCommunication == 2);
      setTableFilterData(tabdata);
    } else setTableFilterData(tabledata);
  };

  const handleClick = (input, data) => {
    if (input === 0) {
      tableDataAll();
    } else if (input === 1) {
      tableDataAll(input);
    }
    setIndex(input);
  };

  const options = [
    {
      label: "All",
      index: 0,
    },
    {
      label: "E-Mail",
      index: 1,
    },
  ];

  return (
    <ManageCommunicationLayout pageName="Communication History">
      <Formik
        initialValues={{
          ...initialValues,
          ...getFlowBasedFormValues(get(state, formName, {}), flow),
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          setFieldError,
          handleSubmit,
          setValues,
          values,
          ...rest
        }) => {
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          const selectedPlan = values[fields.planName];
          return (
            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <div className="HistoryContainer">
                <div className="headervar">
                  <div>
                    <div>
                      <div className="ft-12 ftwt-500 lh-19 dark">
                        Search Communication
                        <span
                          style={{
                            padding: "0.05rem 0.3rem",
                            fontsize: "0.65rem",
                            color: "#828282",
                          }}
                        >
                          (Optional)
                        </span>
                      </div>
                      <Form>
                        <div style={{ width: "350px", height: "52px" }}>
                          <InputGroup>
                            <InputGroup.Prepend>
                              <InputGroup.Text className="plan-search-button">
                                <Image
                                  src="/assets/icons/svg/search.svg"
                                  width="14px"
                                />
                              </InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControlSearch
                              size="md"
                              type="search"
                              label="Search Communication"
                              //className="plan-search-box pad-left-search"
                              clearSearchValue={isClear}
                              placeholder="Search Communication Name, E-Mail id"
                              onChange={(e) => {
                                setFieldValue(fields.search, e.target.value);
                                setIsClear(false);
                              }}
                            />
                          </InputGroup>
                        </div>
                      </Form>
                    </div>
                  </div>
                  <div className="pr-3">
                    <Field
                      size="smd"
                      label="Date range"
                      name={fields.fromDate}
                      value={usDateFormat(values[fields.fromDate])}
                      isDatePicker
                      placeholder="From date"
                      direction="bottom"
                      onClear={() => onDaySelected(fields.fromDate, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.fromDate, value)
                          }
                          value={usDateFormat(values[fields.fromDate])}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="pr-3 to-date-error">
                    <Field
                      size="smd"
                      label=""
                      name={fields.toDate}
                      placeholder="To date"
                      value={usDateFormat(values[fields.toDate])}
                      direction="bottom"
                      isDatePicker
                      onClear={() => {
                        onDaySelected(fields.toDate, null);
                        setFieldError(fields.toDate, '');
                      }}
                      onDefaultClearDisplay={values[fields.toDate]}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.toDate, value)
                          }
                          value={usDateFormat(values[fields.toDate])}
                        />
                      }
                      component={FieldDropSide}
                      validate={(value) => {
                        return [undefined, null, ""].includes(value) ? (
                          ""
                        ) : value < values[fields.fromDate] ? (
                          <div>{"Should be ahead of 'from date' "}</div>
                        ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                        undefined;
                      }}
                    />
                  </div>
                  <div className="pr-2">
                    <Field
                      noLabelTransform
                      label="Plan name"
                      name={fields.planName}
                      value={toMultiSelectValueById(selectedPlan, planList)}
                      direction="bottom"
                      placeholder="All"
                      options={planList}
                      size="smd"
                      leftOffset={110}
                      isMultiSelect
                      popupContent={
                        <div className="no-label-transform">
                          <MultiSelectDropdown
                            noLabelTransform
                            label="Select Plan Name"
                            name={fields.planName}
                            options={planList}
                            width="305px"
                            height="190px"
                            maxHeight="200px"
                            overflow
                            onSelect={(value) =>
                              setFieldValue(fields.planName, value)
                            }
                            value={values[fields.planName]}
                            isManagePage={true}
                            isClear={true}
                            isTypeAhead={true}
                          />
                        </div>
                      }
                      component={FieldDropSide}
                    />
                  </div>

                  <div
                    className={`${
                      values[fields.categorizedLevel] === 2 ||
                      values[fields.categorizedLevel] === 3
                        ? "event-category-var event-category-search"
                        : "event-category-var1 event-category-search"
                    } communication-field-width-flair closeIcon popUpWidth`}
                  >
                    <Field
                      label="Event Category"
                      name={fields.eventCategory}
                      value={values[fields.eventCategory]}
                      direction="bottom"
                      placeholder="Event Category"
                      size="sm"
                      options={CategoryOptions}
                      popupContent={
                        <SearchableList
                          label="Select Category"
                          height="150px"
                          options={CategoryOptions}
                          onSelect={(value) =>
                            setValues({
                              ...values,
                              [fields.eventCategory]: value,
                            })
                          }
                          selectedValue={values[fields.eventCategory]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div
                    className={`${
                      values[fields.categorizedLevel] === 2 ||
                      values[fields.categorizedLevel] === 3
                        ? "event-category-var event-category-search"
                        : "event-category-var1 event-category-search"
                    } communication-field-width-flair closeIcon popUpWidth`}
                  >
                    <Field
                      label="Event Name"
                      name={fields.eventName}
                      value={values[fields.eventName]}
                      direction="bottom"
                      placeholder="Event Name"
                      size="sm"
                      options={eventsList.filter(
                        (x) => x.eventCategory == values.eventCategory
                      )}
                      popupContent={
                        <SearchableList
                          label="Select event name"
                          options={eventsList.filter(
                            (x) => x.eventCategory == values.eventCategory
                          )}
                          onSelect={(value, lable) =>
                            setValues({
                              ...values,
                              [fields.eventName]: lable,
                            })
                          }
                          selectedValue={values[fields.eventName]}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  {/* <div className="mr-26">
                    <Field
                      isRequired
                      label="Type"
                      name={fields.type}
                      value={values[fields.type]}
                      options={typeOptions}
                      direction="bottom"
                      size="sm"
                      popupContent={
                        <SearchableList
                          label="Select Type"
                          options={typeOptions}
                          onSelect={(value) =>
                            setValues({ ...values, type: value })
                          }
                        />
                      }
                      selectedValue={values[fields.type]}
                      component={FieldDropSide}
                    />
                  </div> */}
                  <div className="pl-2 mb-3">
                    <Button
                      variant="secondary"
                      onClick={() => {
                        onDaySelected(fields.fromDate, null);
                        onDaySelected(fields.toDate, null);
                        setFieldValue(fields.planName, []);
                        setFieldValue(fields.eventCategory, null);
                        setFieldValue(fields.eventName, null);
                        setFieldValue(fields.search, "");
                        setFieldError(fields?.toDate, null);
                        setIsClear(true);
                        getSentCommunications({
                          search: "",
                          from: 0,
                          offset: numberOfRecordsToFetch,
                        });
                      }}
                      className=" padding-search-clear-filter"
                    >
                      Clear
                    </Button>
                  </div>
                  <div className="pl-2 mb-3">
                    <Button
                      variant="secondary"
                      type="submit"
                      className=" padding-search-clear-filter"
                    >
                      Search
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>

      <LoaderWrapper isLoading={loading}>
        {/* <div className="pillInputButton mt-1 d-flex mb-10p">
          {options?.map((_) => {
            return (
              <PillComponent
                label={_?.label}
                handleClick={handleClick}
                inputForClick={_?.index}
                className={
                  _?.index == index ? "filteredActiveButton mr-10p" : "mr-10p"
                }
                isInput={false}
              />
            );
          })}
           <Button
              className={smsButton[smsIndex]}
              type="button"
              variant="secondary"
              disabled={false}
              onClick={() => {
                tableDataAll(2);
                setSmsIndex(1);
                setEmailIndex(0);
                setAllIndex(1);
              }}
            >
              SMS
            </Button> 
        </div> */}
        <div
          className="ft-14 mb-9 lh-21"
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "auto",
          }}
        >
          <p>Recently added/Modified</p>
          <p className="cm-found-flair">
            {tabledata.length} Communications found
          </p>
        </div>
        <div style={{ paddingBottom: "60px" }}>
          <div className="chc-grid-flair">
            <Grid
              data={gridData}
              total={tableFilterData.length}
              resizable={true}
              sortable={false}
              sort={sort}
              onScroll={scrollHandler}
              onSortChange={(e) => {
                setSort(e.sort);
              }}
              style={{ maxHeight: "420px" }}
              fixedScroll
            >
              {columns.map((column, idx) => {
                if (column.field == "communicationName")
                  return (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={
                        <div className="grid-column">
                          <div className="ft-14 ftwt-500">{column.label}</div>
                          {/* <i
                            class="fal fa-sort-alpha-down"
                            style={{ marginTop: "2px" }}
                          ></i> */}
                        </div>
                      }
                      filter={column.dataType}
                      cell={communicationNameCell}
                    />
                  );
                else if (column.field == "eventName")
                  return (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={
                        <div className="grid-column">
                          <div className="ft-14 ftwt-500">{column.label}</div>
                          {/* <i
                            class="fal fa-sort-alpha-down"
                            style={{ marginTop: "2px" }}
                          ></i> */}
                        </div>
                      }
                      filter={column.dataType}
                      cell={bindEventName}
                    />
                  );
                else if (column.field == "sentTo")
                  return (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={
                        <div className="grid-column">
                          <div className="ft-14 ftwt-500">{column.label}</div>
                          {/* <i
                            class="fal fa-sort-alpha-down"
                            style={{ marginTop: "2px", marginRight: "10px" }}
                          ></i> */}
                        </div>
                      }
                      filter={column.dataType}
                      cell={sentToCell}
                    />
                  );
                else if (column.field == "date") {
                  return (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={
                        <div className="grid-column">
                          <div className="ft-14 ftwt-500">{column.label}</div>
                          {/* <i
                            class="fal fa-sort-numeric-down"
                            style={{ marginTop: "2px" }}
                          ></i> */}
                        </div>
                      }
                      filter={column.dataType}
                      cell={bindTimeData}
                    />
                  );
                } else if (column.field == "type")
                  return (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={
                        <div className="grid-column">
                          <div className="ft-14 ftwt-500">{column.label}</div>
                          {/* <i
                            class="fal fa-sort-alpha-down"
                            style={{ marginTop: "2px" }}
                          ></i> */}
                        </div>
                      }
                      filter={column.dataType}
                      cell={bindTypeData}
                    />
                  );
              })}
            </Grid>
          </div>
        </div>
      </LoaderWrapper>
    </ManageCommunicationLayout>
  );
};

export default CommunicationHistoryContainer;
